import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import FormHelperText from '@material-ui/core/FormHelperText';
import {authorizedLink} from 'utils'

export class FileUploadField extends PureComponent {

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    required: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
  }

  get fileName() {
    return (this.props.value && this.props.value.name) || ''
  }

  get url() {
    return this.props.value && this.props.value.url && authorizedLink(this.props.value.url)
  }

  handleUploadClick = () => {
    this.fileInput.click()
  }

  handleChange = ({target: { files: [file] }}) => {
    this.props.onChange({target: {value: file}})
  }

  handleClear = () => {
    this.props.onChange({target: {value: null}})
    this.fileInput.value = ""
  }

  renderLabel = () => {
    if (!this.fileName)
      return 'No file attached'

    if (!this.url)
      return this.fileName

    return <a href={this.url} target="_blank" rel='noopener noreferrer'>{this.fileName}</a>
  }

  render = () =>
    <div style={this.props.style} className={styles.wrapper}>
      <input className={styles.fileInput} type="file" ref={fileInput => this.fileInput = ReactDOM.findDOMNode(fileInput)} onChange={this.handleChange} />
      <span className={styles({fileNameLabel: true, hasAttachment: !!this.fileName})}>
        {this.renderLabel()} {!!this.fileName && !this.props.disabled && <span className={styles.removeButton} onClick={this.handleClear}>X</span>}
        { this.props.required && ' *'}
        {this.props.error &&
          <FormHelperText error={true}>{this.props.helperText}</FormHelperText>
        }
      </span>
      <Button disabled={this.props.disabled} className={styles.uploadButton} variant="contained" color="secondary" onClick={this.handleUploadClick}>Browse</Button>
    </div>
}

export const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  fileNameLabel: {
    flex: 1,
    '&$hasAttachment': {
      fontWeight: 500
    }
  },
  hasAttachment: {},
  fileInput: {
    display: 'none'
  },
  uploadButton: {
    margin: 0,
    width: 150,
  },
  removeButton: {
    backgroundColor: '#6AAEAA',
    color: 'white',
    width: 17,
    height: 17,
    display: 'inline-block',
    boxSizing: 'border-box',
    textAlign: 'center',
    paddingTop: 4,
    fontSize: '12px',
    borderRadius: 8,
    fontWeight: 'bold',
    cursor: 'pointer',
    lineHeight: 'normal',
  }
})